import { lazy, Suspense } from 'react';

import { Workflow } from '@/models/workflow';
import { Loading } from '@/routes/SettingsBeta/components/Loading';

const WorkflowViewer = lazy(() => import('../components/WorkflowViewer/WorkflowViewer'));

export const StepsSection = ({ workflow }: { workflow: Workflow }) => {
  return (
    <Suspense fallback={<Loading />}>
      <WorkflowViewer workflow={workflow} />
    </Suspense>
  );
};
